// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Oo-z","badgeLink":"Po-z","category":"Qo-z"};